import { z } from 'zod'

/**
 * Valor em reais como `number`, fonte única do dinheiro (produto, carrinho, pedido e sessão importam daqui).
 *
 * O `decimal` da API sai como número no JSON, mas cópias antigas (produto no carrinho e na vitrine, pedidos antigos)
 * gravaram o valor como texto no Mongo: aceita `"34.90"` e `"34,90"` e converte. Texto vazio ou que não é número falha
 * o parse.
 */
export const MoneySchema = z.preprocess(
    (value) => (typeof value === 'string' && value.trim() !== '' ? Number(value.trim().replace(',', '.')) : value),
    z.number(),
)

export type IMoney = z.infer<typeof MoneySchema>
